module.exports = __webpack_public_path__ + "img/logo.685f1a7b.png";